export default "__VITE_ASSET__DMBGdXqA__"